import React, { useEffect, useState } from 'react'
import { Form } from 'react-final-form'
import Header from '../components/Header/Header'
import LeadsCreditAppStatusTable from './components/LeadsCreditAppStatusTable'
import { useSearchCreditAppStatusMutation } from '../../../services'
import { UspConfigurationCreditAppStatusViewResult } from '../../../models'
import AddEditCreditAppStatusModal from './components/AddEditCreditAppStatusModal'
import { Button, Card, Container, Grid } from '@mui/material'
import CustomBreadcrumbs from '../../../components/custom-breadcrumbs/custom-breadcrumbs'
import Iconify from '../../../components/iconify'

const SettingsLeadsCreditAppStatuses = () => {
  const [rowData, setRowData] = useState({})
  const [openAddEditModal, setOpenAddEditModal] = useState(false)
  const [type, setType] = useState('')
  const [searchCreditAppStatus, { data, isLoading }] = useSearchCreditAppStatusMutation()
  const [creditAppStatusData, setCreditAppStatusData] = useState<UspConfigurationCreditAppStatusViewResult[]>([])

  const handleSubmit = (values?: any) => {
    searchCreditAppStatus({
      simpleSearch: {
        searchString: values?.searhString,
        isIncludeInactive: values?.isIncludeInactive,
      },
    })
  }

  const handleOpenModal = () => {
    setOpenAddEditModal(true)
    setType('add')
  }

  const handleCloseModal = () => {
    setOpenAddEditModal(false)
  }

  useEffect(() => {
    if (data) {
      setCreditAppStatusData(data)
    }
  }, [data])

  return (
    <Container>
      <CustomBreadcrumbs
        heading='Credit App Statuses'
        links={[
          {
            name: 'List',
          },
        ]}
        action={
          <Button onClick={handleOpenModal} variant='contained' startIcon={<Iconify icon='mingcute:add-line' />}>
            Add new
          </Button>
        }
        sx={{
          mb: {
            xs: 3,
            md: 5,
          },
        }}
      />
      <Form onSubmit={handleSubmit} initialValues={{ searhString: null, isIncludeInactive: false }}>
        {({ handleSubmit, form: { submit } }: any) => (
          <>
            <form onSubmit={handleSubmit}>
              <Card>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <Header submit={submit} title='' handleOpenModal={handleOpenModal} />
                  </Grid>
                  <Grid item xs={12}>
                    <LeadsCreditAppStatusTable
                      setOpenAddEditModal={setOpenAddEditModal}
                      setType={setType}
                      setRowData={setRowData}
                      loading={isLoading}
                      data={creditAppStatusData}
                      setData={setCreditAppStatusData}
                    />
                  </Grid>
                </Grid>
              </Card>
            </form>
            <AddEditCreditAppStatusModal
              submit={submit}
              open={openAddEditModal}
              onClose={handleCloseModal}
              type={type}
              rowData={rowData as UspConfigurationCreditAppStatusViewResult}
            />
          </>
        )}
      </Form>
    </Container>
  )
}

export default SettingsLeadsCreditAppStatuses
